import React from "react";
import {
  FluentProvider,
  webLightTheme,
} from "@fluentui/react-components";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

import LabourLibraryPage from "./pages/LabourLibraryPage";
import MaterialLibraryPage from "./pages/MaterialLibraryPage";
import Quotes from "./pages/Quotes";
import QuotesList from "./pages/QuotesList";
import QuoteDetails from "./pages/QuoteDetails";

import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import Overview from "./pages/Overview";
import Customers from "./pages/Customers";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import Economy from "./pages/Economy";
import Todo from "./pages/Todo";
import Settings from "./pages/Settings";
import QuoteEditorPage from "./components/QuoteEditor";

function AppShell() {
  return (
    <div className="flex h-screen bg-[#f3f2f1] text-[#323130]">
      {/* Sidebar */}
      <div className="w-[260px] border-r border-gray-200 bg-white">
        <Sidebar />
      </div>

      {/* Main area */}
      <div className="flex flex-1 flex-col">
        {/* Topbar */}
        <div className="border-b border-gray-200 bg-white">
          <Topbar />
        </div>

        {/* Content */}
        <main className="flex-1 overflow-auto p-6">
          <div className="mx-auto max-w-[1400px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              element={
                <ProtectedRoute>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Overview />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetails />} />
              <Route path="/economy" element={<Economy />} />
              <Route path="/todo" element={<Todo />} />
              <Route path="/quotes" element={<Quotes />} />
              <Route path="/quotes/:id" element={<QuoteDetails />} />
              <Route path="/quotes-list" element={<QuotesList />} />
              <Route path="/quotes-list/:id" element={<QuotesList />} />
              <Route path="/quote-editor/:id" element={<QuoteEditorPage />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/libraries/labour" element={<LabourLibraryPage />} />
              <Route path="/libraries/materials" element={<MaterialLibraryPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </FluentProvider>
  );
}